// Root node of the provenance DAG: campaign-level summary.

import { Handle, Position } from '@xyflow/react';
import { fallbackTheme } from './theme';
import { NODE_SIZES } from './provenanceLayout';

export interface CampaignNodeData {
  name: string;
  createdAt: string;
  configSummary: string;
}

export default function CampaignNode({ data }: { data: CampaignNodeData }) {
  const t = fallbackTheme;
  const { width, height } = NODE_SIZES.campaign;
  return (
    <div
      style={{
        width,
        height,
        background: t.surfaceRaised,
        border: `1px solid ${t.borderStrong}`,
        borderRadius: 10,
        padding: '12px 14px',
        color: t.text,
        fontSize: 12,
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        boxShadow: '0 2px 8px rgba(0,0,0,0.35)',
      }}
    >
      <div style={{ fontSize: 11, color: t.textMuted, letterSpacing: 0.5, textTransform: 'uppercase' }}>
        Campaign
      </div>
      <div style={{ fontSize: 14, fontWeight: 600, lineHeight: 1.2 }} title={data.name}>
        {data.name}
      </div>
      <div style={{ fontSize: 11, color: t.textMuted }}>{data.configSummary}</div>
      <div style={{ fontSize: 10, color: t.textMuted, marginTop: 'auto' }}>
        {formatDate(data.createdAt)}
      </div>
      <Handle type="source" position={Position.Bottom} style={{ background: t.border }} />
    </div>
  );
}

function formatDate(iso: string): string {
  try {
    const d = new Date(iso);
    return d.toLocaleString(undefined, {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return iso;
  }
}
